/*
	Corrige mayúsculas de lo que se teclea (Esteban, 2026-09-23): "MARIA PEREZ" o "maria perez"
	quedan "Maria Perez"; las partículas van en minúscula ("Claudia del Cid") y una palabra con
	mayúsculas a propósito en medio ("McAllister") no se toca. Es la MISMA regla que
	App\Common\TextoPropio del backend (que manda al guardar); si cambia una, cambia la otra.
*/
const PARTICULAS_NOMBRE = ["de", "del", "la", "las", "los", "y", "e", "da", "das", "do", "dos", "van", "von", "der", "di"];
const PARTICULAS_TEXTO = ["de", "del", "la", "las", "los", "y", "e", "el", "en", "a", "al", "para", "por", "con", "o", "u"];
const SIGLAS = [
	"CONALEP", "CETIS", "CBTIS", "CBTA", "CECATI", "CECYTE", "CECYTEM", "COBACH", "COBAEM", "CEBETIS", "UANL", "UNAM", "IPN", "ITESM",
	"UDEM", "UVM", "UPN", "UR", "UTH", "UNAH", "UNITEC", "UNICAH", "UJCV", "UPI", "USAP", "INFOP", "SEP", "IMSS", "ISSSTE", "TEC",
	"CUM", "ICATEH", "ICATECH", "CCH", "ENP", "UAT", "UAC", "UACH", "UADEC", "UTT", "UTC", "DGETI", "INEA", "CEDVA", "IEU"
];
const ROMANOS = ["I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X", "XI", "XII"];

const palabra = (p: string, primera: boolean, particulas: string[], esTexto: boolean): string => {
	for (const sep of ["-", "'"]) {
		if (p.includes(sep) && p.length > 1) {
			return p.split(sep).map((parte, k) => (parte === "" ? parte : palabra(parte, primera && k === 0, particulas, esTexto))).join(sep);
		}
	}
	if (!/\p{L}/u.test(p)) {
		return p;
	}
	const limpia = p.replace(/[^\p{L}]/gu, "").toUpperCase();
	const mayus = p.toUpperCase();
	const minus = p.toLowerCase();
	if (esTexto) {
		if (/\d/.test(p)) return p;
		if (SIGLAS.includes(limpia) || (ROMANOS.includes(limpia) && !primera)) return mayus;
	}
	if (!primera && particulas.includes(minus)) {
		return minus;
	}
	const toda = p === mayus || p === minus;
	const empiezaMinuscula = p.charAt(0) !== p.charAt(0).toUpperCase();
	return toda || empiezaMinuscula ? minus.charAt(0).toUpperCase() + minus.slice(1) : p;
};

const corregir = (texto: string | null | undefined, particulas: string[], esTexto: boolean, continua: boolean = false): string => {
	const t = String(texto ?? "").replace(/\s+/g, " ").trim();
	return t === "" ? t : t.split(" ").map((p, i) => palabra(p, i === 0 && !continua, particulas, esTexto)).join(" ");
};

/**
 * Nombres y apellidos. continua = el campo va después de otro nombre (los apellidos), así que una
 * partícula al principio también va en minúscula: "del Cid", no "Del Cid".
 */
export const nombrePropioTexto = (texto: string | null | undefined, continua: boolean = false): string => corregir(texto, PARTICULAS_NOMBRE, false, continua);
/** Dirección, ciudad, escuela, ocupación: respeta números, siglas y romanos. */
export const textoPropio = (texto: string | null | undefined): string => corregir(texto, PARTICULAS_TEXTO, true);
/** "MADRE" / "madre" → "Madre". */
export const primeraMayuscula = (texto: string | null | undefined): string => {
	const t = String(texto ?? "").replace(/\s+/g, " ").trim();
	if (t === "") return t;
	const minus = t.toLowerCase();
	return t === t.toUpperCase() || t === minus || t.charAt(0) !== t.charAt(0).toUpperCase() ? minus.charAt(0).toUpperCase() + minus.slice(1) : t;
};
